var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@brushfire/ui";
var StatusIndicator = function (_a) {
    var isComplete = _a.isComplete, _b = _a.isCancelled, isCancelled = _b === void 0 ? false : _b, isSaving = _a.isSaving, isGifted = _a.isGifted, isPreRegistered = _a.isPreRegistered, isActive = _a.isActive, _c = _a.postAttendee, postAttendee = _c === void 0 ? false : _c, _d = _a.isAddon, isAddon = _d === void 0 ? false : _d;
    var color = isCancelled
        ? "ink"
        : isSaving
            ? "warning"
            : !isComplete && isPreRegistered && postAttendee
                ? "danger"
                : isComplete || isPreRegistered
                    ? "info"
                    : isActive
                        ? "gray"
                        : "color-disabled";
    if (isGifted) {
        color = "info";
    }
    return (_jsx("div", __assign({ className: "status-indicator" }, { children: _jsxs("div", __assign({ className: "status-indicator-icon" }, { children: [!isGifted && !isCancelled && (_jsx(_Fragment, { children: isSaving ? (_jsx(Icon, { icon: "spinner-third", classes: "fa-fw  fa-spin fade-in ".concat(isSaving ? "active" : "") })) : (_jsx(Icon, { icon: isComplete
                            ? "".concat(isAddon ? "box" : "memo", "-circle-check")
                            : isPreRegistered
                                ? "memo-circle-info"
                                : isAddon
                                    ? "box"
                                    : "memo", classes: "fa-fw ".concat(color, " ").concat(isPreRegistered ? "prereg-icon" : ""), type: "solid" })) })), isGifted && !isCancelled && _jsx(Icon, { type: "solid", icon: "gift", classes: "fa-fw info" }), isCancelled && _jsx(Icon, { type: "solid", icon: "circle-xmark", classes: "fa-fw gray" })] })) })));
};
export default StatusIndicator;
